import { useContext, useState } from "react";
import PsContext from "../../../context";
import {
  apiFolderFileLinks,
  DB_POSTFIX,
  themeColor,
  upperCase,
} from "../../../utils";
import SearchPage from "./SearchPage";

const HeaderLogo = () => {
  const [showSearch, setShowSearch] = useState(false);
  const context = useContext(PsContext);

  return (
    <div className="section d-none d-md-block">
      <div className="container">
        <div
          className="row py-1"
          style={{ borderBottom: "1px solid #8686869d" }}
        >
          <div className="col-md-6">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <a href="/">
                  {" "}
                  <img
                    src={apiFolderFileLinks(
                      context.settingValue("web_site_top_logo")
                    )}
                    style={{ width: "100%" }}
                  />
                </a>
              </div>
            </div>
          </div>

          <div className="col-md-6 d-flex justify-content-end gap-4 align-items-center">
            <div className="d-flex align-items-center px-2 py-1 header-box">
              An Institute of Eminence
              <i
                className="fas fa-award ms-2"
                style={{ color: themeColor, fontSize: "16px" }}
              ></i>
            </div>

            <div
              className="d-flex align-items-center"
              onClick={() => setShowSearch(true)}
              style={{ cursor: "pointer" }}
            >
              <span
                className="fw-bold"
                style={{ fontSize: "15px", letterSpacing: "1px" }}
              >
                Search on {upperCase(DB_POSTFIX)}
              </span>
              <i
                className="fas fa-search ms-2"
                style={{ color: themeColor, fontSize: "18px" }}
              ></i>
            </div>

            <div className="d-flex align-items-center">
              <img
                src="https://portal.aei.edu.in//files_list/aei/drsacoe/fm/website/home/main-logo.png"
                alt=""
                style={{ width: "80px" }}
              />
            </div>
          </div>
        </div>

        <div className="row d-block d-sm-none">
          {" "}
          <div
            className="search-bar d-flex mb-3"
            onClick={() => setShowSearch(true)}
          >
            <input
              type="text"
              className="form-control search-input"
              placeholder="Enter your search"
            />
            <button className="search-btn">
              <i className="fas fa-search"></i>
            </button>
          </div>
        </div>
      </div>

      {showSearch && <SearchPage onClose={() => setShowSearch(false)} />}
    </div>
  );
};

export default HeaderLogo;
